export const prebidConfig = {
  enableTIDs: true,
  debug: true,
  enableSendAllBids: true, // Sends all bids, not just the highest one
  bidderSequence: "random",
  
  currency: {
    enabled: true,
    defaultCurrency: 'USD',
    conversionRates: {
      USD: { USD: 1.00, EUR: 0.85, GBP: 0.74, JPY: 146.78, AUD: 1.51, CAD: 1.39, CHF: 0.80, CNY: 7.12 },
      EUR: { EUR: 1.00, USD: 1.18, GBP: 0.87, JPY: 172.39, AUD: 1.78, CAD: 1.64, CHF: 0.94, CNY: 8.37 },
      GBP: { GBP: 1.00, USD: 1.35, EUR: 1.15, JPY: 197.83, AUD: 2.04, CAD: 1.88, CHF: 1.07, CNY: 9.60 },
      JPY: { JPY: 1.00, USD: 0.0068, EUR: 0.0058, GBP: 0.0051, AUD: 0.0103, CAD: 0.0095, CHF: 0.0054, CNY: 0.0486 },
      AUD: { AUD: 1.00, USD: 0.66, EUR: 0.56, GBP: 0.49, JPY: 97.00, CAD: 0.92, CHF: 0.53, CNY: 4.71 },
      CAD: { CAD: 1.00, USD: 0.72, EUR: 0.61, GBP: 0.53, JPY: 105.35, AUD: 1.09, CHF: 0.57, CNY: 5.11 },
      CHF: { CHF: 1.00, USD: 1.26, EUR: 1.06, GBP: 0.93, JPY: 184.50, AUD: 1.89, CAD: 1.75, CNY: 8.94 },
      CNY: { CNY: 1.00, USD: 0.14, EUR: 0.12, GBP: 0.10, JPY: 205.50, AUD: 0.21, CAD: 0.20, CHF: 0.11 }
    },
    // placeholder — will be set below
    defaultRates: {}
  },

  // **Client-Side Bidders (Cookie-Based SSPs in Prebid.js)**
  bidders: ["smartyads, rubicon, appnexus, amx, equativ, medianet, onetag, rise, ttd, unruly" ],
  bidderSettings: {
    appnexus: {
      storageAllowed: true,
    },
    bitmedia: {
      storageAllowed: true,
    },
    amx: {
      storageAllowed: true,
    },
    onetag: {
      storageAllowed: true,
    }
  },

  // **Server-to-Server (Prebid Server) Configuration**
  s2sConfig: {
    accountId: "your-prebid-account",
    enabled: true,
    bidders: ["districtm"],
    timeout: 1500,
    endpoint: "https://localhost:8443/openrtb2/auction",
    syncEndpoint: "https://localhost:8443/cookie_sync",
    adapter: "prebidServer",
    debug: true,
    bidderControl: {
      districtm: {
        bidSource: { server: 0, client: 100 },
        includeSourceKvp: true
      }
    }
  },

  // **Testing Server-to-Server (S2S) Bidders**
  s2sTesting: {
    enabled: false,
    bidders: ["districtm"], // Ensures all S2S bidders are tested
    bidResponse: {
      cpm: 2.50,
      currency: "USD",
      width: 300,
      height: 250,
      ad: "<html><body><h1>Test Ad</h1></body></html>"
    }
  },

  // **Auction Settings**
  bidderTimeout: 2200, // Adjusted to prevent unnecessary timeouts

  /* *Floor Pricing Configuration**
  
    floors: {
        enabled: true,
        enforcement: { enforceJS: true, enforcePBS: true },
        auctionDelay: 50,
        data: {
          currency: "USD",
          modelVersion: "1.0",
          schema: {
                fields: [ 'mediaType', 'adUnitCode' ]
            },
          values: {
            "banner|inarticle-paragraph3": 0.20, 
            "banner|navbar-ad": 0.20,
            "banner|sidebar-top": 0.09

          },
          "default": 0.20
        }
    },
  */

  // **Supply Chain Object (for Ad Transparency)**
  schain: {
    config: {
      ver: "1.0", // Version of schain
      complete: 1, // 1 = all intermediaries are included in the chain
      nodes: [
        { asi: "smartyads.com", sid: "20524", hp: 1 },
        { asi: "rubicon.com", sid: "319994", hp: 1 },
        { asi: "appnexus.com", sid: "16345139", hp: 1 },
        { asi: "bitmedia.io", sid: "yyy", hp: 1 }
      ]
    } 
  },

  // **GDPR, GPP & CCPA Support**
  consentManagement: {
    gdpr: {
      cmpApi: "iab",
      timeout: 2000,
      defaultGdprScope: true
    },
    usp: {
      cmpApi: "iab",
      timeout: 2000
    },
    gpp: {
      enabled: true,
      cmpApi: "iab",
      timeout: 2000
    },
    allowAuctionWithoutConsent: true, // Prevents Prebid from blocking if CMP is missing
  },

  // **Children's Online Privacy Protection Act (COPPA) Compliance**
  coppa: 0,

  userSync: {
    syncEnabled: true, 
    filterSettings: {
      iframe: { bidders: '*', filter: 'include' }, 
      image: { bidders: '*', filter: 'exclude' }  //Disable image syncs (to limit tracking)
    },
    syncDelay: 3000,  // Delay sync to avoid performance issues
    maxRequestsPerOrigin: 2, // Prevent excessive sync requests
    userIds: [
      {
        name: 'pubCommonId',
        storage: {
          type: 'html5',         // or 'cookie'
          name: '_pubcid',       // key name in storage
          expires: 365
        },
        storageAllowed: true     
      }
    ]
  }

};

prebidConfig.currency.defaultRates = prebidConfig.currency.conversionRates;

// NOTE: assumes prebidConfig is already declared above in the same module/file
export const prebidRatesReady = (async function updateRates() {
  const url = 'https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json';
  try {
    console.info('[Prebid] Fetching currency rates...');
    const res = await fetch(url, { cache: 'no-cache' });
    if (!res || !res.ok) {
      console.warn(`[Prebid] Currency fetch failed: HTTP ${res && res.status}`);
      return false;
    }
    const json = await res.json();
    if (!json || !json.conversions || !Object.keys(json.conversions).length) {
      console.warn('[Prebid] Currency file missing conversions — keeping defaults');
      return false;
    }

    // round helper for storage (2 decimals)
    const round2 = v => Math.round(v * 100) / 100;

    // merge fetched into existing defaults so you keep your manual 'major' set
    const fetched = json.conversions;
    const merged = { ...(prebidConfig.currency.conversionRates || {}) };

    Object.keys(fetched).forEach(from => {
      merged[from] = merged[from] || {};
      Object.keys(fetched[from]).forEach(to => {
        const val = fetched[from][to];
        if (typeof val === 'number') merged[from][to] = round2(val);
        else merged[from][to] = val;
      });
      // ensure identity mapping
      merged[from][from] = merged[from][from] || 1;
    });

    // set both conversionRates and defaultRates so prebid currency module has fallback
    prebidConfig.currency.conversionRates = merged;
    prebidConfig.currency.defaultRates = merged;

    console.info('[Prebid] Currency rates merged and stored. bases:', Object.keys(merged));

    // BUILD a canonical uppercase runtime table for fast lookups
    function buildRuntimeTable(raw) {
      const t = {};
      Object.keys(raw || {}).forEach(from => {
        const F = String(from).toUpperCase();
        t[F] = {};
        Object.keys(raw[from] || {}).forEach(to => {
          t[F][String(to).toUpperCase()] = Number(raw[from][to]);
        });
        t[F][F] = 1;
      });
      return t;
    }

    const runtimeTable = buildRuntimeTable(prebidConfig.currency.conversionRates || {});

    // attach "full" convertCurrency to window.mypbjs (idempotent)
    (function attachFullConvertCurrency() {
      if (typeof window === 'undefined' || !window.mypbjs) return;
      // don't overwrite if already installed by a previous run (but replace old stub if present)
      // we'll always install/replace to ensure the full version is active
      const table = runtimeTable;
      const rateCache = {};
      window.__mypbjs_currency_warned = window.__mypbjs_currency_warned || {};

      function computeRate(F, T) {
        const key = `${F}->${T}`;
        if (rateCache[key] != null) return rateCache[key];

        // direct
        if (table[F] && typeof table[F][T] === 'number') return (rateCache[key] = table[F][T]);

        // reciprocal
        if (table[T] && typeof table[T][F] === 'number') {
          const r = Number((1 / table[T][F]).toFixed(6));
          return (rateCache[key] = r);
        }

        // pivot via USD (common case)
        if (F !== 'USD' && table[F] && typeof table[F]['USD'] === 'number' && table['USD'] && typeof table['USD'][T] === 'number') {
          const r = Number((table[F]['USD'] * table['USD'][T]).toFixed(6));
          return (rateCache[key] = r);
        }

        // pivot via first base currency
        const bases = Object.keys(table);
        if (bases.length) {
          const base = bases[0];
          if (table[base] && typeof table[base][F] === 'number' && typeof table[base][T] === 'number') {
            const fToBase = 1 / table[base][F];
            const r = Number((fToBase * table[base][T]).toFixed(6));
            return (rateCache[key] = r);
          }
        }

        return null;
      }

      window.mypbjs.convertCurrency = function(amount, fromCurrency = (prebidConfig.currency.defaultCurrency || 'USD'), toCurrency = (prebidConfig.currency.defaultCurrency || 'USD')) {
        if (amount == null) return NaN;
        const F = String(fromCurrency).toUpperCase();
        const T = String(toCurrency).toUpperCase();
        if (F === T) return Number(amount);

        const rate = computeRate(F, T);
        const warnKey = `FULL_NO_PATH:${F}->${T}`;

        if (rate == null) {
          // warn only once per missing path
          if (!window.__mypbjs_currency_warned[warnKey]) {
            console.warn(`[convertCurrency] full implementation: no conversion path ${F} -> ${T}. Returning original amount. Configure currency rates/defaultRates to include this path.`);
            window.__mypbjs_currency_warned[warnKey] = true;
          }
          return Number(amount);
        }

        return Number(Number(amount) * rate);
      };

      console.info('[PrebidRates] full convertCurrency attached to window.mypbjs');
    })();

    // Reapply the currency block to the running mypbjs (safe: we only set currency)
    try {
      if (typeof window !== 'undefined' && window.mypbjs && Array.isArray(window.mypbjs.que)) {
        window.mypbjs.que.push(() => {
          try {
            window.mypbjs.setConfig({ currency: prebidConfig.currency });
            console.info('[Prebid] Reapplied merged currency rates to mypbjs (rounded)');
          } catch (e) {
            console.warn('[Prebid] Failed to reapply fetched currency rates', e);
          }
        });
      } else {
        console.debug('[Prebid] mypbjs not yet available to reapply currency config');
      }
    } catch (e) {
      /* ignore */
    }

    return true;
  } catch (err) {
    console.warn('[Prebid] Could not fetch currency rates (using defaults)', err);
    return false;
  }
})();

